import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import ChanceVisual from '../ChanceVisual';
import { useT } from '../../i18n/LanguageContext';

export default function SectionChance() {
  const { t } = useT();

  return (
    <SectionShell id="chance" centerContent className="relative overflow-hidden">
      {/* Backdrop wash */}
      <div
        className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          background:
            'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.05) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.03) 0%, transparent 55%)',
        }}
      />
      <div className="relative grid grid-cols-12 gap-y-12 md:gap-12 items-stretch">
        <div className="col-span-12 md:col-span-6 flex flex-col justify-center">
          <Reveal>
            <div className="overline mb-6">{t.chance.overline}</div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[1] mb-10 text-white">
              {t.chance.title}
            </h2>
            <p className="font-ui text-2xl lg:text-3xl text-white/70 max-w-[52ch] leading-relaxed mb-10">
              {t.chance.body}
            </p>
            <div className="glass p-8 md:p-10 rounded-sm max-w-[56ch]">
              <div className="font-display text-2xl md:text-3xl text-white/90 leading-snug">
                &ldquo;{t.chance.callout}&rdquo;
              </div>
              <div className="mt-6 overline text-white/50 text-base">— STIG ROCK</div>
            </div>
          </Reveal>
        </div>
        <div className="col-span-12 md:col-span-6 flex">
          <Reveal delay={220} className="w-full h-full block">
            <ChanceVisual />
          </Reveal>
        </div>
      </div>
    </SectionShell>
  );
}
